import { CustomInputEvent } from "types/commonExtend/CustomInputEvent";

type OnChangeHelperType = (onChangeFunction: (text: string) => void) => (event: CustomInputEvent) => void;

export const onChangeHelper: OnChangeHelperType = (onChangeFunction) => {
  return (event) => {
    onChangeFunction(event.target.value);
  };
};
